import instance from "../../utils/axios";

export const endSubCategoryTime = async (subCategoryID, activityId) => {
  try {
    if (!activityId) {
      throw new Error("Activity Id is required.");
    }
    if (!subCategoryID) {
      throw new Error("SubCategory ID is required.");
    }
    return await instance.get(
      `/end-time-in-subcategory/${encodeURIComponent(
        subCategoryID
      )}/${encodeURIComponent(activityId)}`
    );
  } catch (error) {
    console.error("Error fetching subcategories:", error.message);
    throw error;
  }
};
